import { styled } from '@mui/material/styles'
import React from 'react'
import Kheader, { HeadingLevel } from './Kheader'

const PREFIX = 'Kdivider'

const classes = {
  divider: `${PREFIX}-divider`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }: any) => ({
  [`& .${classes.divider}`]: {
    width: '100%',
    height: '3px',
    backgroundColor: theme.palette.primary.light,
    marginTop: '20px',
  },
}))

type Props = {
  title?: string
  headingLevel?: HeadingLevel
}

const Kdivider: React.FC<Props> = (props) => {
  return (
    <Root>
      <div className={classes.divider}></div>
      {!!props.title && <Kheader {...props} />}
    </Root>
  )
}

export default Kdivider
